import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import DateSlot from '@components/DataGrid/DateSlot';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const headerDisplayName = 'Appt';

const pickupTimeDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'APPT',
	minWidth: 120,
	width: 120,
	headerName: 'APPT',
	headerDisplayName,
	renderHeader: () => <RenderHeader primaryText={headerDisplayName} />,
	renderCell: ({ row }) => <RenderCell primarySlot={<DateSlot toDate={row.pickupDate} />} />,
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { pickupTime } = row;
				return caseInsensitiveIncludes(value, pickupTime);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.pickupDate?.date ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default pickupTimeDefinition;
